import Store from '@cb/solaris-react/Utility/Store';
const TOKEN_LOCAL_STORAGE_KEY = 'tokenData';
export default class TokenStore extends Store {
    _persistenceStore;
    _loadPromise;
    _hasLoaded = false;
    constructor(persistenceStore) {
        super({
            tokenData: null,
            isLoading: false,
        });
        this._persistenceStore = persistenceStore;
        // Persist token data when it changes
        this.on('tokenData', async () => {
            await this.persist();
        });
    }
    async ensureLoaded() {
        if (this._hasLoaded) {
            return;
        }
        if (!this._loadPromise) {
            this._loadPromise = this.load();
        }
        await this._loadPromise;
        this._hasLoaded = true;
        this._loadPromise = undefined;
    }
    async persist() {
        if (this.state.tokenData) {
            await this._persistenceStore.setItem(TOKEN_LOCAL_STORAGE_KEY, this.state.tokenData);
        }
        else {
            await this._persistenceStore.removeItem(TOKEN_LOCAL_STORAGE_KEY);
        }
    }
    async load() {
        this.setState('isLoading', true);
        const tokenData = await this._persistenceStore.getItem(TOKEN_LOCAL_STORAGE_KEY);
        if (tokenData) {
            this.setState('tokenData', tokenData);
        }
        else {
            this.setState('tokenData', null);
        }
        this.setState('isLoading', false);
    }
}
//# sourceMappingURL=TokenStore.js.map